import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  Stack,
  useTheme,
  useMediaQuery,
  styled,
  ThemeProvider,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import Logo from "../assets/images/Logo.png";
// Styled components
const FooterContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "#151C2E", // Dark navy blue background
  color: "white",
  padding: theme.spacing(6, 0, 2, 0),
}));

const FooterLink = styled(Link)({
  color: "white",
  textDecoration: "none",
  display: "block",
  marginBottom: "12px",
  "&:hover": {
    textDecoration: "underline",
  },
});

const SocialIcon = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "36px",
  height: "36px",
  borderRadius: "50%",
  backgroundColor: "",
  color: "white",
  marginRight: theme.spacing(1),
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.1)",
  },
}));

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <div className=" px-5 lg:px-24">
        <Grid container spacing={4}>
          {/* Logo and Company Description */}
          <Grid item xs={12} md={4}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <Box
                component="img"
                src={Logo} // Replace with the path to your logo image
                alt="Logo"
                sx={{
                  height: "3.5rem", // Adjust the height as needed
                  mr: 0.5,
                }}
              />
            </Box>
            <ThemeProvider theme={theme}>
              <Box
                component="div"
                sx={{
                  fontSize: "0.9rem",
                  color: "rgba(255, 255, 255, 0.6)",
                  mb: 2,
                  maxWidth: "350px",
                  fw: 1, // Set to a very light value
                }}
              >
                {/* Integrity for what we build, the purpose of why we build and the
                people who inspire us to build. It's what Builder is built upon,
                and why our homes are as far from ordinary as the people who
                live in them. */}
              </Box>
            </ThemeProvider>
          </Grid>

          {/* Information Links */}
          <Grid item xs={6} sm={6} md={2}>
            <Box
              sx={{
                mb: 2,
                color: "rgba(255, 255, 255, 0.6)",
                fontSize: "0.9rem",
              }}
            >
              {/* Information */}
            </Box>
            <Box sx={{ fontWeight: 400 }}>
              <FooterLink href="/products">Products</FooterLink>
              <FooterLink href="/contactUs">Contact Us</FooterLink>
              <FooterLink href="/careers">Careers</FooterLink>
              <FooterLink href="/parkerStore">Parker Store</FooterLink>
            </Box>
          </Grid>

          {/* Company Links */}
          <Grid item xs={6} sm={6} md={2}>
            <Typography
              variant="h6"
              sx={{ visibility: isSmall ? "hidden" : "visible" }}
            >
              {/* &nbsp; */}
            </Typography>
            <Box sx={{ pt: 2, fontWeight: 400 }}>
              <FooterLink href="/about/our-company">Our History</FooterLink>
              <FooterLink href="/about/awards">
                Awards & Success Stories
              </FooterLink>
              {/* <FooterLink href="/about/awards"></FooterLink> */}
              <FooterLink href="/about/leadership">Leaderships</FooterLink>
            </Box>
          </Grid>

          {/* Contact Information */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                mb: 2,
                color: "rgba(255, 255, 255, 0.6)",
                fontSize: "0.9rem",
              }}
            >
              Our Office
            </Box>

            {/* Address */}
            <Box
              sx={{ display: "flex", mb: 2, color: "rgba(255, 255, 255, 0.6)" }}
            >
              <LocationOnIcon sx={{ color: "#AB052D", mr: 1, mt: 0.5 }} />
              <Box>
                L-4130/2, Phase IV, G.I.D.C.
                <br />
                B/H New Nirma
                <br />
                Vatva,Ahmedabad-382445.
              </Box>
            </Box>

            {/* Email */}
            <Box
              sx={{ display: "flex", mb: 2, color: "rgba(255, 255, 255, 0.6)" }}
            >
              <EmailIcon sx={{ color: "#AB052D", mr: 1, mt: 0.5 }} />
              <Box>
                <Box>
                  <a
                    href="mailto:sales@siskon.in"
                    className="hover:underline"
                    style={{ color: "inherit", textDecoration: "none" }}
                  >
                    sales@siskon.in
                  </a>
                </Box>
                <Box>
                  <a
                    href="mailto:sanjay.jain@siskon.in"
                    className="hover:underline"
                    style={{ color: "inherit", textDecoration: "none" }}
                  >
                    sanjay.jain@siskon.in
                  </a>
                </Box>
                <Box>
                  <a
                    href="mailto:ishan.jain@siskon.in"
                    className="hover:underline"
                    style={{ color: "inherit", textDecoration: "none" }}
                  >
                    ishan.jain@siskon.in
                  </a>
                </Box>
              </Box>
            </Box>

            {/* Phone */}
            <Box
              sx={{ display: "flex", mb: 2, color: "rgba(255, 255, 255, 0.6)" }}
            >
              <PhoneIcon sx={{ color: "#AB052D", mr: 1, mt: 0.5 }} />
              <Box>
                <Box>
                  <a
                    href="tel:+919898507238"
                    className="hover:underline"
                    // style={{ color: "inherit", textDecoration: "none" }}
                  >
                    +91 9898507238
                  </a>
                </Box>
              </Box>
            </Box>

            {/* Business Hours */}
            <Box
              sx={{ display: "flex", mb: 3, color: "rgba(255, 255, 255, 0.6)" }}
            >
              <AccessTimeIcon sx={{ color: "#AB052D", mr: 1, mt: 0.5 }} />
              <Box>Mon – Sat: 9:00 AM – 6:00 PM</Box>
            </Box>
          </Grid>
        </Grid>

        {/* Copyright and Social Media */}
        <Box
          sx={{
            borderTop: "1px solid rgba(255, 255, 255, 0.1)",
            mt: 4,
            pt: 2,
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "space-between",
            alignItems: isMobile ? "center" : "flex-start",
            gap: 2,
          }}
        >
          <Box
            color="rgba(255, 255, 255, 0.6)"
            sx={{
              fontSize: "0.9rem",
              display: "flex",
              flexDirection: { xs: "column", sm: "row" }, // Stack on mobile (xs), row on tablet+ (sm)
              alignItems: { xs: "flex-start", sm: "center" }, // Align start on mobile, center on larger screens
              gap: { xs: 0.5, sm: 1 }, // Adjust gap for mobile and desktop
              textAlign: { xs: "left", sm: "left" }, // Ensure text aligns left on mobile
            }}
          >
            <span>© {currentYear} Copyright. All Right Reserved.</span>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mt: { xs: 0.5, sm: 0 }, // Add margin-top on mobile for spacing
              }}
            >
              <span>Made by </span>
              <Link
                href="http://www.valuessquare.com"
                target="_blank"
                sx={{
                  textDecoration: "underline",
                  mx: 0.5,
                  color: "inherit",
                  "&:hover": {
                    color: "#1e90ff",
                  },
                }}
              >
                Values Square
              </Link>
              <Box
                component="img"
                src="/assets/image/vs.png"
                alt="Logo"
                sx={{
                  height: "1.5rem",
                  marginLeft: "0.5rem",
                }}
              />
            </Box>
          </Box>

          <Stack direction="row" spacing={1}>
            <SocialIcon>
              <a
                href="https://twitter.com/siskonventure"
                target="_blank"
                rel="noopener noreferrer"
              >
                <TwitterIcon />
              </a>
            </SocialIcon>
            {/*<SocialIcon>
              <a href="#" target="_blank" rel="noopener noreferrer">
                <FacebookIcon />
              </a>
            </SocialIcon>*/}
            <SocialIcon>
              <a
                href="https://www.instagram.com/siskonventurespvt/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramIcon />
              </a>
            </SocialIcon>
            <SocialIcon>
              <a
                href="https://www.linkedin.com/company/siskon-ventures-pvt-ltd/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedInIcon />
              </a>
            </SocialIcon>
          </Stack>
        </Box>
      </div>
    </FooterContainer>
  );
};

export default Footer;
{
  /* <Box
            color="rgba(255, 255, 255, 0.6)"
            sx={{
              fontSize: "0.9rem",
              display: "flex",
              alignItems: "center",
              gap: 1, // Adds spacing between the logo and text
            }}
          >
            © {currentYear} Copyright. All Right Reserved.
            <br className="block sm:hidden"/>
             Made by Values Square
            <Box
              component="img"
              src="/assets/image/vs.png" // Replace with the path to your logo
              alt="Logo"
              sx={{
                height: "1.5rem", // Adjust the height as needed
              }}
            />
          </Box> */
}
{
  /* <Box color="rgba(255, 255, 255, 0.6)" sx={{ fontSize: "0.9rem",border: "1px solid red" }}>
            © {currentYear} Copyright. All Right Reserved.
            <br />{" "}
            <span className="flex items-center w-full mt-1">
              Made by{" "}
              <a
                href="http://www.valuessquare.com"
                target="_blank"
                className="underline mx-1 hover:text-blue-700"
              >
                {" "}
                Value Square{" "}
              </a>
              <img className="w-5 h-5 mx-3" src="/assets/image/vs.png"  alt="" />
            </span>
          </Box> */
}
